import * as THREE from 'three';
import { FeatureTopologyDisplayEdgesResourceFactory } from './FeatureTopologyDisplayEdgesResourceFactory';

/**
 * 特征拓扑合并显示边。
 *
 * 设计说明：
 * 1. 该对象只负责浏览态“带边线上色”的默认黑色边线；
 * 2. 它不参与选择，点击边线仍由 `FeatureResultMesh.attachFeatureLineByIndex()` 动态创建真实代理；
 * 3. 一个结果体只创建一个 `LineSegments`，避免每条边一个 Object3D 带来的渲染和遍历开销。
 */
export class FeatureTopologyDisplayEdgesMesh extends THREE.LineSegments {
  //------ 模型显示模式 开始------
  /** 合并显示边渲染顺序，低于动态 FeatureLine 的 renderOrder=2。 */
  private static readonly BACKGROUND_DISPLAY_EDGE_RENDER_ORDER = 1;
  //------ 模型显示模式 结束------

  /**
   * 构造函数。
   *
   * @param snapshot 权威拓扑快照。
   * @param color 显示边颜色。
   */
  public constructor(
    snapshot: TopologySnapshot,
    color: THREE.ColorRepresentation = 0x000000,
  ) {
    super(
      FeatureTopologyDisplayEdgesResourceFactory.createGeometry([snapshot]),
      FeatureTopologyDisplayEdgesResourceFactory.createMaterial(color),
    );
    this.name = '__feature_topology_display_edges__';
    this.renderOrder = FeatureTopologyDisplayEdgesMesh.BACKGROUND_DISPLAY_EDGE_RENDER_ORDER;
    this.frustumCulled = false;
    this.userData = {
      ...this.userData,
      skipSelection: true,
      skipSelectionSubtree: true,
      isFeatureTopologyDisplayEdges: true,
    };
  }

  /**
   * 设置显示边颜色。
   *
   * @param color 目标颜色。
   */
  public setDisplayEdgeColor(color: THREE.ColorRepresentation): void {
    const materialList = Array.isArray(this.material) ? this.material : [this.material];
    materialList.forEach((material) => {
      if (!(material instanceof THREE.LineBasicMaterial)) {
        return;
      }

      // 不着色模式会随主题切换黑白边线，复用已有材质避免重建几何。
      material.color.set(color);
      material.needsUpdate = true;
    });
  }

  /**
   * 释放显示边资源。
   */
  public dispose(): void {
    this.removeFromParent();
    this.geometry.dispose();
    const material = this.material;
    if (Array.isArray(material)) {
      material.forEach((item) => item.dispose());
      return;
    }
    material.dispose();
  }
}
